import { render, staticRenderFns } from "./S6.vue?vue&type=template&id=554d79c7&scoped=true&"
import script from "./S6.vue?vue&type=script&lang=js&"
export * from "./S6.vue?vue&type=script&lang=js&"
import style0 from "./S6.vue?vue&type=style&index=0&id=554d79c7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554d79c7",
  null
  
)

export default component.exports